import React, { createContext, useContext, useState } from 'react';
import { useAuth } from "./AuthProvider";
import { AddProductToFavorite, RemoveProductFromFavorite, GetFavoriteProducts } from '../Services/ProductService';
import { toast } from 'react-toastify';
import { useConfig } from './ConfigProvider';

const FavoriteProductsContext = createContext()

export const useFavoriteProducts = () => {
    return useContext(FavoriteProductsContext)
}

export const FavoriteItemsProvider = ({ children }) => {
    const { authState } = useAuth()
    const { api } = useConfig()
    const [selectedProducts, setSelectedProducts] = useState([])

    const addProductToFavorite = async (artNo) => {
        try {
            if (!validateArtNo(artNo)) {
                toast.error('Bląd w trakcie pobierania indeksu')
                return false
            }
            await AddProductToFavorite(api, artNo)
            return true
        } catch (error) {
            if (error.response.status === 409) {
                toast.warning('Przekroczono maksymalną liczbę produktów dodanych do ulubionych!')
                return false
            }
            else {
                console.log(error)
                toast.error('Nie udało się dodać produktu do ulubionych!')
                return false
            }
        }
    }
    const removeProductFromFavorite = async (artNo) => {
        if (!validateArtNo(artNo)) {
            toast.error('Bląd w trakcie pobierania indeksu')
            return false
        }
        try {
            await RemoveProductFromFavorite(api, artNo)
            return true
        } catch (error) {
            console.log(error)
            toast.error('Nie udało się usunąć produktu z ulubionych!')
            return false
        }
    }
    const validateArtNo = (value) => {
        if (value === null || value === undefined || value === '') {
            return false
        }
        return true
    }
    const getFavoriteProducts = async (custId) => {
        try {
            const result = await GetFavoriteProducts(api, custId, authState.siteId, authState.whId)
            return result.data
        } catch (e) {
            console.log(e)
            return []
        }
    }


    return (
        <FavoriteProductsContext.Provider value={{
            selectedProducts,
            setSelectedProducts,
            addProductToFavorite,
            removeProductFromFavorite,
            getFavoriteProducts
        }}>
            {children}
        </FavoriteProductsContext.Provider>
    )
}